import styled from 'styled-components';
export const Text = styled.header `
  font-size: 16px;
`;
//# sourceMappingURL=components.js.map